import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

export default function SelectReportExecution({...props}) {
    const myProps = {
        isSearchable: false,
        placeholder: 'Select report execution',
        icon: { icon: 'file-alt' },
        isMulti: false,
        isClearable: true,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
